import toAttachmentInputItem from '@/redux/requests/lib/toAttachmentInputItem.js';

/** The input items of one message: its text, then one item per uploaded file. Empty when there is nothing to send. */
const buildRequestInput = ({ prompt, attachments = [] }) => {
  const text = String(prompt || '').trim();
  const files = attachments.map((uploadResult) => toAttachmentInputItem({ uploadResult })).filter(Boolean);

  return [...(text ? [{ type: 'text', text }] : []), ...files];
};

export default buildRequestInput;
